import React, { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { getTheme, toggleThemeWithReveal } from '../../theme';

/** Prekidač svetla/tamna tema.
    Dan: nebo sa svetlim horizontom, sunce sa zracima koji se okreću i pulsirajućim sjajem, oblaci koji plove.
    Noć: duboko nebo sa maglinom, zvezde koje trepere, zvezda padalica, mesec sa kraterima i senkom. Krug se širi iz prekidača. */
export default function ThemeToggle({ className = '' }) {
    const [theme, setTheme] = useState(getTheme());

    /* sinhronizacija sa drugim tabom */
    useEffect(() => {
        const sync = () => setTheme(getTheme());
        window.addEventListener('storage', sync);
        return () => window.removeEventListener('storage', sync);
    }, []);

    const dark = theme === 'dark';
    const label = dark ? 'Tamna tema uključena — uključi svetlu' : 'Svetla tema uključena — uključi tamnu';

    /* prekidač se prebacuje ODMAH (pre prelaza teme), pa prelaz kreće iz već prebačenog prekidača */
    const toggle = (e) => {
        const r = e.currentTarget.getBoundingClientRect();
        flushSync(() => setTheme(dark ? 'light' : 'dark'));
        Promise.resolve(toggleThemeWithReveal({ x: r.left + r.width / 2, y: r.top + r.height / 2 })).then(setTheme);
    };

    return (
        <button type="button" role="switch" aria-checked={dark} className={`theme-switch${dark ? ' noc' : ''} ${className}`.trim()}
            onClick={toggle} title={label} aria-label="Tamna tema">
            <span className="ts-nebo" aria-hidden="true">
                <span className="ts-maglina" />
                <span className="ts-zvezde">{Array.from({ length: 9 }, (_, i) => <i key={i} />)}</span>
                <span className="ts-padalica" />
                <span className="ts-oblaci"><i /><i /><i /></span>
                <span className="ts-brda" />
            </span>
            <span className="ts-kugla" aria-hidden="true">
                <span className="ts-zraci" />
                <span className="ts-disk">
                    <span className="ts-krateri"><i /><i /><i /><i /></span>
                </span>
            </span>
        </button>
    );
}
